'use client';

/**
 * ConnectionStatus - WebSocket 연결 상태 표시 컴포넌트
 *
 * Description: WebSocket 연결이 끊어졌을 때 헤더 하단에 표시되는 알림 배너.
 *   - 연결된 상태에서는 완전히 숨겨져 UI를 방해하지 않음
 *   - 연결 끊김 감지 시 부드러운 슬라이드 애니메이션으로 등장
 *   - 자동 재연결 중임을 사용자에게 명확히 안내
 */

import React from 'react';
import { useWebSocket } from '@/hooks/useWebSocket';
import { useAuth } from '@/hooks/useAuth';
import styles from './ConnectionStatus.module.css';

export default function ConnectionStatus() {
  const { isAuthenticated } = useAuth();
  const { isConnected } = useWebSocket();

  // 미인증 상태에서는 WebSocket이 연결되지 않으므로 표시하지 않음
  if (!isAuthenticated) return null;

  // 연결된 상태에서는 렌더링하지 않아 DOM을 가볍게 유지
  if (isConnected) return null;

  return (
    <div className={styles.banner} role="status" aria-live="polite" aria-label="서버 연결 끊김">
      {/* 펄스 애니메이션 도트 */}
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.message}>
        서버 연결이 끊어졌습니다. 자동으로 재연결을 시도 중입니다...
      </span>
    </div>
  );
}
